const UPLOAD_FOLDER_BASE_URL = "http://byteplay-backend.onrender.com/uploads/"

const stables = { UPLOAD_FOLDER_BASE_URL };

export default stables
